/**
 * @prettier
 */
import { ExternalDeliveryProvider, ExternalDeliveryProviders } from 'src/constants/ExternalDeliveryProviders';

export function isUberEatsExternalDeliveryProvider(deliveryProvider?: ExternalDeliveryProvider): boolean {
    return deliveryProvider === ExternalDeliveryProviders.UBER_EATS;
}
